import React from 'react';
import { FormControl, InputLabel, MenuItem, Typography, Select } from '@mui/material';
import { useAudioInputDevices } from '../deviceHooks/deviceHooks';
import useVideoContext from '../../../../hooks/useVideoContext/useVideoContext';
import { useTranslation } from 'react-i18next';
import { LocalAudioTrack } from 'twilio-video';

export default function AudioInputList() {
  const audioInputDevices = useAudioInputDevices();
  const {
    room: { localParticipant },
    localTracks,
    getLocalAudioTrack,
  } = useVideoContext();

  const localAudioTrack = localTracks.find((track) => track.kind === 'audio') as LocalAudioTrack;
  const localAudioInputDeviceId = localAudioTrack?.mediaStreamTrack.getSettings().deviceId;

  function replaceTrack(newDeviceId: string) {
    localAudioTrack?.stop();
    getLocalAudioTrack(newDeviceId)
      .then((newTrack) => {
        if (localAudioTrack) {
          const localTrackPublication = localParticipant?.unpublishTrack(localAudioTrack);
          // TODO: remove when SDK implements this event. See: https://issues.corp.twilio.com/browse/JSDK-2592
          localParticipant?.emit('trackUnpublished', localTrackPublication);
        }

        return localParticipant?.publishTrack(newTrack);
      })
      .catch(() => {
        // Replacing track can fail if media permission is blocked.
      });
  }

  const { t } = useTranslation();
  return (
    <div className="inputSelect">
      {audioInputDevices.length > 1 ? (
        <FormControl fullWidth>
          <InputLabel id="audio-input-select-label" shrink>
            {t('select-microphone')}
          </InputLabel>
          <Select
            labelId="audio-input-select-label"
            label={t('select-microphone')}
            onChange={(e) => replaceTrack(e.target.value as string)}
            value={localAudioInputDeviceId || ''}
          >
            {audioInputDevices.map((device) => (
              <MenuItem value={device.deviceId} key={device.deviceId}>
                {device.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <>
          <Typography variant="h6">{t('select-microphone')}</Typography>
          <Typography>{localAudioTrack?.mediaStreamTrack.label || t('no-local-audio')}</Typography>
        </>
      )}
    </div>
  );
}
